const validarTelefono = (telefono) => {
    if (telefono.length < 10 || !telefono.match(/^[0-9]{10}$/)) {
        return false
    }
    return true;
}


const validarEmail = (email) => {
    return email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
}


export { validarTelefono, validarEmail }